import styled from 'styled-components';


export const NavWrap = styled.nav<{isCollapsed:boolean}>`
  display: ${(props) => (props.isCollapsed ? 'none' : 'block')};
`;

export const Aside = styled.aside<{ isCollapsed: boolean }>`
  position: sticky;
  top: 0;
  height: 100vh;
  width: 76px;
  background: #000;
  
  /* Use transform instead of width for 60fps smoothness */
  transform: ${(props) => (props.isCollapsed ? 'translateX(-76px)' : 'translateX(0)')};
  
  /* Hide the gap left behind when collapsed */
  margin-right: ${(props) => (props.isCollapsed ? '-76px' : '0')};
  
  /* Transition transform and margin together */
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), margin-right 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  
  will-change: transform;
  backdrop-filter: saturate(160%) blur(8px);
`;

export const NavContainer = styled.div`
  display: flex; 
  min-height: calc(100vh - 48px);
  background: #000;
  color: #BFBFBF;  
`;

export const NavButton = styled.button<{isActive:boolean,extendedHeight:boolean}>`
    width:100%;
    height:${(props) => (props.extendedHeight ? '52px' : '44px')};;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: ${(props) => (props.isActive ? '1px solid #404040;' : 'none')};
    border-radius:4px;
    background: ${(props) => (props.isActive ? '#404040' : 'transparent')};
    cursor: pointer;
    color: #ebf0f7ff;
    font-family: 'Roboto', 'Montserrat', sans-serif;
    font-size: 10px;
    position: relative;
    font-weight:'600';
    
    :hover { 
      background: #404040; 
    }

`;

export const ProductButton = styled.div<{ isCollapsed: boolean }>`
  position: fixed;
  left:0;
  bottom: 15px;
  background: #111;
  width: 76px;
  text-align: center;
  /* Mirror Aside's collapse behavior since this sits outside the Aside tree */
  transform: ${(props) => (props.isCollapsed ? 'translateX(-76px)' : 'translateX(0)')};
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: ${(props) => (props.isCollapsed ? 'none' : 'auto')};

  && button {
  width: 96%;
  min-width: 0;
  min-height: 64px;
  padding: 8px 4px;
  background: #111;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;

  &:hover {
    background: #404040;
    color: #fff;
  }

  &:focus {
    background: #111;
    color: #fff;
  }

  &:focus-visible {
    background: #111;
    color: #fff;
    outline: 2px solid #4d90fe;
  }
}

  && button span {
    line-height: 15px;
    text-align: center;
    white-space: pre-line;
  }
`;

export const NavList = styled.ul`
    list-style: none; 
    margin: 6px 0 8px;
    padding: 0; 
    display: flex; 
    flex-direction: column; 
    gap: 12px; 
    margin-left:7px;
    margin-right:7px;
`;

export const NavIconStack = styled.span`
    display: flex; 
    flex-direction: column; 
    align-items: center; 
    justify-content: center; 
    gap: 2px; 
`;

export const NavLabel = styled.div`
    font-size: 10px;  
    font-weight: 600; 
    text-align: center;
`;

export const NavGrabber = styled.div<{isCollapsed:boolean}>`
    display: ${(props) => (props.isCollapsed ? 'block' : 'none')};
    position: absolute;
    left: 2px;
    top: calc(50% - 48px);
    transform: translateY(-50%);
    width: 10px;
    height: 40px;
    background:
      linear-gradient(#8e8e8e,#8e8e8e) left 2px center / 2px 100% no-repeat,
      linear-gradient(#8e8e8e,#8e8e8e) right 2px center / 2px 100% no-repeat;
    border-radius: 4px;
`;
